// extracted by mini-css-extract-plugin
export var content = "_dk-3";
export var list = "_dk-4";
export var settingsContent = "_dk-7";
export var settingsPanel = "_dk-8";
export var state = "_dk-6";
export var triggerBadge = "_dk-2";
export var triggerButton = "_dk-1";
export var triggerShell = "_dk-0";
export var unreadDot = "_dk-5";